import objFactory from "_src/engine/factories/object";
import FrameBuffer from "_src/engine/framebuffer";
import primitiveFactory from "_src/engine/factories/primitive";
import {
  primitiveType,
  pixelBufferType,
  blendFactor,
  stencilAction,
  stencilFunc,
  drawMode,
  RBIntFormat,
  attachmentId
} from "_src/engine/constants";

import Pass from "_src/render_graph/pass";
import resourceManager from "_src/render_graph/resource_manager";
import ScreenShader from "_src/shaders/screen/screen";
import CopyShader from "_src/shaders/copy/copy";
import config from "_src/config";

export default class SelectionPass extends Pass {

  constructor(attachmentsStorage, camera) {

    super(attachmentsStorage);

    this.init(camera);

  }

  init(camera) {

    const drawScene = this._addScene(camera);
    const blendSnece = this._addScene(camera);
    const copyScene = this._addScene(camera);

    blendSnece.clearedColor = false;
    blendSnece.clearedStencil = false;

    copyScene.clearedColor = false;
    copyScene.clearedStencil = false;

    const drawShader = new ScreenShader({transparent : true, backFaceCulling : false});
    drawShader.drawColor = false;
    drawShader.enableStencilTest();
    drawShader.setStencilFrontZPassAction(stencilAction.INCR);
    drawShader.setStencilBackZPassAction(stencilAction.DECR);

    const blendShader = new ScreenShader({transparent : true, backFaceCulling : false});
    blendShader.setSourceBlendFactor(blendFactor.ONE);
    blendShader.enableStencilTest();
    blendShader.setStencilFunction(stencilFunc.NOTEQUAL);
    blendShader.setStencilReferenceValue(127);

    const copyShader = new CopyShader({transparent : true});

    const drawScreenPlane = objFactory.createDrawable(drawShader);
    drawScreenPlane.addGeometryChunk(primitiveFactory.create(primitiveType.SCREEN_QUAD));

    const lassoChunk = drawScreenPlane.chunks[0];
    lassoChunk.setDrawMode(drawMode.TRIANGLE_FAN);
    lassoChunk.cleanup();

    const blendScreenPlane = objFactory.createDrawable(blendShader);
    blendScreenPlane.addGeometryChunk(primitiveFactory.create(primitiveType.SCREEN_QUAD));

    drawScreenPlane.setOpacity(0.5);
    blendScreenPlane.setOpacity(0.3);

    const sc = config.selectionColor;
    blendScreenPlane.setDiffuseColor(sc.r, sc.g, sc.b);

    const copyScreenPlane = objFactory.createDrawable(copyShader);
    copyScreenPlane.addGeometryChunk(primitiveFactory.create(primitiveType.SCREEN_QUAD));

    drawScene.add(drawScreenPlane);
    blendSnece.add(blendScreenPlane);
    copyScene.add(copyScreenPlane);

  }

  update() {

    const drawScene = this.getMainScene();
    const blendSnece = this.getSecondScene();
    const copyScene = this.getLastScene();

    const width = drawScene.camera.viewport[2];
    const height = drawScene.camera.viewport[3];

    const { drawFrameBuffer, copyFrameBuffer } = this.initFramebuffer(width, height);

    drawScene.setFramebuffer(drawFrameBuffer);
    blendSnece.setFramebuffer(drawFrameBuffer);
    copyScene.setFramebuffer(copyFrameBuffer);

  }

  initFramebuffer(width, height) {

    const mainColorTexture = this.attachmentsStorage[attachmentId.OUTPUT_COLOR_TEXTURE];
    const mainDepthBuffer = this.attachmentsStorage[attachmentId.INTERFACE_DEPTH];

    const colorTexture = resourceManager.initBuffer(pixelBufferType.T_RGBA,
        { width, height });

    const format = RBIntFormat.DS;
    const depthStencilBuffer = resourceManager.initBuffer(pixelBufferType.RB_DEPTH,
                  { width, height, format });

    const copyScene = this.getLastScene();
    const copyScreenPlane = this.getScreenQuad(copyScene);
    copyScreenPlane.setTexture(colorTexture, 0);

    const drawFrameBuffer = new FrameBuffer([colorTexture], depthStencilBuffer);
    const copyFrameBuffer = new FrameBuffer([mainColorTexture], mainDepthBuffer);

    return { drawFrameBuffer, copyFrameBuffer };

  }

}
